export const featureFlag = {
  // GrowthOS Feature Flags
  geographies: "growth_os_geographies",
  campaignInsights: "growth_os_campaign_insights",
  brandEquity: "growthos_brand_equity",
  growthCentre: "growthos_growth_centre",
  scenarioBuilderApi: "growthos_scenario_builder_api",
  topNavLayout: "growthos_top_nav_layout",
  brandEquityV2: "growth_os_brand_equity_v2",
  // Metric Options Feature Flags
  salesUnitsEnabled: "growthos_sales_units",
  // New Model Outputs Drawer to Render New Route
  // Dynamic Module Control - controls which modules use new vs old endpoints
  dynamicModuleControl: "growthos_insights_controller_model_outputs",
  // Scenario Builder Feature Flags
  scenarioBuilderApprovalsWorkflow: "growthos_scenario_builder_approvals_workflow",
  scenarioDebugMode: "growth_os_scenario_v3_debug",
  scenarioBuilderV3: "growthos_scenario_builder_rebuild_for_geo",
  scenarioBuilderSimulatedUnits: "growthos_scenario_builder_simulated_units",
  scenarioBuilderRisk: "growthos_scenario_builder_risk",
  scenarioBuilderActionPlans: "growthos_scenario_builder_action_plans",
  /**
   * Enables the new constraints from the API and surfaces the risk via the banner in the scenario form and results page
   */
  scenarioBuilderConstraintsFromApi: "scenario_builder_use_constraints_from_api",
  scenarioBuilderOverrideStartDateHandler: "override_scenario_start_date_handler",
  /**
   * Controls whether the customer has geographies for Scenario Builder coming from CMS (false) or from the model (true)
   */
  scenarioGeographyEnabledFromModel: "growthos_scenario_geography_enabled_from_model",
  /**
   * Controls whether the customer has geographies for Scenario Builder
   */
  scenariosWithGeography: "growthos_scenarios_with_geography",
  /**
   * Controls the new default node name behavior using warchestNode.extras.mappedName
   */
  scenarioPortfolioDropdown: "growthos_scenario_portfolio_dropdown",
  // MAITE Feature Flags
  maiteAnswerFeedback: "maite_answer_feedback",
  maiteAnswerDebug: "maite_answer_debug",
  maiteChatHistory: "maite_chat_history",
  maiteEnableCharting: "maite_enable_charting",
  maiteQueryToggle: "maite_query_toggle",
  hendrenUseScenariosTool: "hendren_use_scenarios_tool",
  growthosHendrenDocumentsInput: "growthos_hendren_documents_input",
  /**
   * Controls enabling a debug view for spend allocation to help with internal development
   */
  scenarioDebugSpendAllocationView: "growthos_scenario_debug_spend_allocation",
  maiteChat: "growthos_maite_chat",
  mroiBubbleChartComparison: "growthos_mroi_bubble_chart_comparison",
  enableWarc: "maite_warc_enabled",
  maiteV2Enabled: "maite_v2_enabled",
  growthosDebugFlag: "growthos_debug_flag",
};

export type FeatureName = keyof typeof featureFlag;
